const topicPeopleOverlay = () => {
    if(document.querySelector('.kirinus-topics__button')) {
        const allPeopleOverlayButtons = document.querySelectorAll('.kirinus-topics__button');

        allPeopleOverlayButtons.forEach((item, index) => {
            item.addEventListener('click', function (el) {
                this.classList.toggle('is-open');
                this.closest('.kirinus-topics-card').classList.toggle('kirinus-topics-card--overlay-show');
            })
        });
    }

    if(document.querySelector('.kirinus-topics-card .btn-black')) {
        const allPeopleBtnLink = document.querySelectorAll('.kirinus-topics-card .btn-black');
        allPeopleBtnLink.forEach((item, index) => {
            item.style.setProperty('--btn-width', `${item.clientWidth}px`);
        });
    }
}

export default topicPeopleOverlay;

